<template>
  <div id="load-order-create-loading" class="vs-con-loading__container">
    <vs-card>
      <vs-row style="margin-bottom: 15px">
        <vs-col>
          <h4>Información de Transportista</h4>
          <div>
            <table style="margin-left: 3em">
              <tr>
                <td class="font-semibold">{{ $t('carrier') | capitalize }}:</td>
                <td class="pl-2">{{ transporterCheckInfo.Transportista }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Número Economico:</td>
                <td class="pl-2">
                  {{ transporterCheckInfo.Numero_Economico }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ $t('requirement_number') | capitalize }}:
                </td>
                <td class="pl-2">{{ transporterCheckInfo.Pedimento }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ $tc('type') | capitalize }}
                  {{ $tc('container') | capitalize }}:
                </td>
                <td class="pl-2">{{ transporterCheckInfo.Tipo_Contenedor }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('plates') | capitalize }}:</td>
                <td class="pl-2">{{ transporterCheckInfo.Placas_USA }}</td>
              </tr>
              <tr>
                <td class="font-semibold">CAAT:</td>
                <td class="pl-2">{{ transporterCheckInfo.CAAT }}</td>
              </tr>
              <tr>
                <td class="font-semibold">SCAC:</td>
                <td class="pl-2">{{ transporterCheckInfo.SCAC }}</td>
              </tr>
            </table>
          </div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <review-order-import
            v-model="invoices"
            @deleteItem="resetCheckInfo"
            :showCheckbox="false"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-justify="flex-end">
        <vs-col vs-w="2" vs-type="flex" class="my-2">
            <vs-button color="primary" class="w-full" @click="showBackValidations" 
            :disabled="invoices.tables.length==0">
                {{$t('validate')}}
            </vs-button>
        </vs-col>
      </vs-row>
    </vs-card>

    <vs-popup
          :title="$t('attention') | capitalize"
          color="danger"
          :active.sync="modal_info_active"
        >
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-2"
        >
          <vs-col>
            {{modal_text}}<br />
            <ul type="”A”" v-if="modal_ul_items.length>0">
              <li v-for="(item, index) in modal_ul_items" :key="index">
                - {{ item }}
              </li>
            </ul>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2"
          >
            <vs-button
              color="primary"
              class="w-full"
              @click="modal_info_active = false"
              >{{ $t('ok')|capitalize }}</vs-button
            >
          </vs-col>
        </vs-row>
    </vs-popup>

    <vs-popup :title="$t('validations')|capitalize" :active.sync="modal_compare">
      <vs-row>
        <vs-col >
        <div v-if="errorsSameInfo.length == 0 && validationErrors[0].length == 0">
          <vs-avatar color="success" icon="check" class="custom-icon" />
          Archivo sin errores de Validación.
        </div>
        <div v-else style="color: red" class="mb-2">
          <template v-if="validationErrors[0].length != 0">
          <div v-for="(error, i) in validationErrors" :key="i">
            <vs-divider color="danger" class="my-6 f-14 f-bold">
              {{ files[i] }}
            </vs-divider>

             <div class="vx-row text-center validations-list">
          <div class="vx-col w-full" v-for="(e, i) in error" :key="i">
            <div class="div-validation-list"  v-if="e=='The trailer is not found.'">
              <vs-avatar color="danger" icon="close" class="custom-icon icon-validation-list" />
              <span class="f-12 text-validation-list">{{ e }}</span>
            </div>
             <div v-else class="div-validation-list">
                    <vs-avatar color="danger" icon="close" class="custom-icon icon-validation-list" />
                    <span class="f-12 text-validation-list">{{ e }}</span>
              </div>
          </div>
        </div>


            <!-- <div v-for="(e, j) in error" :key="'A' + j">
              
                <div style="display:'flex-inline'" v-if="e=='The trailer is not found.'">
                  <vs-avatar color="danger" icon="close" class="custom-icon" />{{e}}
                  <vs-button @click="openAddTrailer" color="success">
                    {{$t('add')|capitalize}} {{$t('trailer')|capitalize}}
                  </vs-button>
                </div>

                <div v-else>
                    <vs-avatar color="danger" icon="close" class="custom-icon" />{{e}}
                </div>
            </div> -->
          </div>
          </template >
          <template>
            <div v-if="errorsSameInfo.length != 0"  class="mb-2">
          <h4>Diferencias encontradas</h4>
          <div :key="indextr" v-for="(row, indextr) in errorsSameInfo">
            <template  v-if="row.length>0">
              <vs-divider color="danger" class="my-6 f-14 f-bold">
              {{ files[indextr] }}
            </vs-divider>

            <vs-table :data="row">
              <template slot="thead">
                  <vs-th></vs-th>
              </template>
              <template>
                  <vs-tr :key="indextr" v-for="(trow, indextr) in row">
                    <vs-td col-span="3">{{ trow[0] }}</vs-td>
                    <template slot="expand">
                      <vs-table :data="trow[1]">
                      <template slot="thead">
                        <vs-th></vs-th>
                        <vs-th>System</vs-th>
                        <vs-th>Invoice</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="kkey" v-for="(tr, kkey) in data">
                          <vs-td>{{ tr[0] }}</vs-td>
                          <vs-td>{{ tr[2] }}</vs-td>
                          <vs-td>{{ tr[1] }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                    </template>
                  </vs-tr>
              </template>
            </vs-table>  
            </template>
                           
          </div>            
          </div>
          </template>
         
        </div>
        </vs-col>
      </vs-row>
      <!-- <vs-row vs-type="flex" vs-justify="flex-end">
        <vs-col vs-w="4">
          <vs-button @click="modal_compare=false">{{
            $t('go_back') | capitalize
          }}</vs-button>
        </vs-col>
        <vs-col vs-w="4">
          <vs-button :disabled="errorsSameInfo.length != 0 || validationErrors[0].length != 0" color="success" @click="submit">
            Enviar
          </vs-button>
        </vs-col>
      </vs-row> -->
      <vs-row vs-justify="center" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
            class="mx-1"
          >
            <vs-button @click="modal_compare=false" type="border" color="primary">{{
            $t('go_back') | capitalize
          }}</vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
            class="mx-1"
            
          >
            <vs-button :disabled="errorsSameInfo.length != 0 || validationErrors[0].length != 0" type="filled" color="primary" @click="submit">
            Enviar
          </vs-button>
          </vs-col>
        </vs-row>
    </vs-popup>

    <add-trailer-sidebar :params="trailerInfo"></add-trailer-sidebar>
  </div>
</template>

<script>
import ReviewOrderImport from '@/views/modules/import_export/review_order/components/ReviewOrderImport'
import loadOrder from '@/http/requests/loadOrder'
import loading from '@/mixins/Loading'
import AddTrailerSidebar from './components/AddTrailerSidebar'

export default {
  mixins: [loading],
  components: {
    ReviewOrderImport,
    AddTrailerSidebar
  },
  data() {
    return {
      modal_info_active: false,
      modal_compare: false,
      modal_text: '',
      modal_ul_items: [],
      invoices: {
        tables: []
      },
      files: [],
      transporterCheckInfo: [],
      missingInfo: []
      , loading: {
        checkingInvoices: false,
        validationBack: false,
        submit: false
      },
      errorsSameInfo: [],
      validationErrors: [[]],
      trailerInfo: {
      }
    }
  },
  watch: {
    invoices() {
      this.files = this.invoices.tables.map(table => table.fileName)
      let out = this.checkTransporterInfo(this.invoices)
      if (out != '') {
        this.modal_info_active = true
        this.modal_text = out

        let index = this.invoices.tables.length - 1
        this.invoices.tables.splice(index, 1);
      }
      if (this.modal_info_active == false && this.invoices.tables.length > 0) {
        this.compareReviewOrderInvoices()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading('load-order-create-loading')
      } else {
        this.closeLoading('load-order-create-loading')
      }
    }
  },
  computed: {
    isLoading() {
      return (
        this.loading.checkingInvoices ||
        this.loading.validationBack ||
        this.loading.submit
      )
    }
  },
  methods: {
    checkTransporterInfo(loadOrders) {
      let sameInfo = true;
      let missingInfo = []
      let out_message = ''
      let messages_out = [
        'Información de Transportista Faltante:',
        'La Información de Transportista no coincide, por favor Verifica la información.',
        'El folio que intenta agregar ya existe.'
      ]

      if (loadOrders.tables.length > 0) {
        //Check that Transporter info is complete
        let lastInsert = loadOrders.tables[loadOrders.tables.length - 1].json[0]
        if (lastInsert['Transportista'] == undefined || lastInsert['Transportista'] == '') {
          missingInfo[missingInfo.length] = 'Nombre de Transportista.'
          out_message = messages_out[0]
        }
        if (lastInsert['Numero Economico'] == undefined || lastInsert['Numero Economico'] == '') {
          missingInfo[missingInfo.length] = 'Número Economico.'
          out_message = messages_out[0]
        }
        if (lastInsert['Pedimento'] == undefined || lastInsert['Pedimento'] == '') {
          missingInfo[missingInfo.length] = 'Pedimento.'
          out_message = messages_out[0]
        }
        if (lastInsert['Tipo Contenedor'] == undefined || lastInsert['Tipo Contenedor'] == '') {
          missingInfo[missingInfo.length] = 'Tipo Contenedor.'
          out_message = messages_out[0]
        }
        if (lastInsert['Placas USA'] == undefined || lastInsert['Placas USA'] == '') {
          missingInfo[missingInfo.length] = 'Placas USA.'
          out_message = messages_out[0]
        }
        if (lastInsert['CAAT'] == undefined || lastInsert['CAAT'] == '') {
          missingInfo[missingInfo.length] = 'CAAT.'
          out_message = messages_out[0]
        }
        if (lastInsert['SCAC'] == undefined || lastInsert['SCAC'] == '') {
          missingInfo[missingInfo.length] = 'SCAC.'
          out_message = messages_out[0]
        }
        if (missingInfo.length > 0) {
          sameInfo = false
        }

        //Validate - Same tranporter data in last uploaded file
        loadOrders.tables.forEach(item => {
          if (sameInfo) {
            //If it is the first file, save data to compare in future
            if (this.transporterCheckInfo.length == 0) {
              this.transporterCheckInfo = {
                Transportista: item.json[0].Transportista,
                Numero_Economico: item.json[0]['Numero Economico'],
                Pedimento: item.json[0].Pedimento,
                Tipo_Contenedor: item.json[0]['Tipo Contenedor'],
                Placas_USA: item.json[0]['Placas USA'],
                CAAT: item.json[0].CAAT,
                SCAC: item.json[0].SCAC
              }
              //Info to add trailer sidebar
              this.trailerInfo = {
                name: item.json[0]['Numero Economico'],
                container_type: item.json[0]['Tipo Contenedor'],
                plates: item.json[0]['Placas USA'],
                caat: item.json[0].CAAT,
                scac: item.json[0].SCAC,
                transporter: item.json[0].Transportista
              }
            }
            //If is NOT the first uploaded file, compare transporter data with the first one
            if (this.transporterCheckInfo.Transportista != item.json[0].Transportista) {
              missingInfo[missingInfo.length] = 'Nombre: ' + this.transporterCheckInfo.Transportista + ' / ' + item.json[0].Transportista
              out_message = messages_out[1]
              sameInfo = false
            }
            if (this.transporterCheckInfo.Numero_Economico != item.json[0]['Numero Economico']) {
              missingInfo[missingInfo.length] = 'Número Económico: ' + this.transporterCheckInfo.Numero_Economico + ' / ' + item.json[0]['Numero Economico']
              out_message = messages_out[1]
              sameInfo = false
            }
            if (this.transporterCheckInfo.Pedimento != item.json[0].Pedimento) {
              missingInfo[missingInfo.length] = 'Pedimento: ' + this.transporterCheckInfo.Pedimento + ' / ' + item.json[0].Pedimento
              out_message = messages_out[1]
              sameInfo = false
            }
            if (this.transporterCheckInfo.Tipo_Contenedor != item.json[0]['Tipo Contenedor']) {
              missingInfo[missingInfo.length] = 'Tipo Contenedor: ' + this.transporterCheckInfo.Tipo_Contenedor + ' / ' + item.json[0]['Tipo Contenedor']
              out_message = messages_out[1]
              sameInfo = false
            }
            if (this.transporterCheckInfo.Placas_USA != item.json[0]['Placas USA']) {
              missingInfo[missingInfo.length] = 'Placas USA: ' + this.transporterCheckInfo.Placas_USA + ' / ' + item.json[0]['Placas USA']
              out_message = messages_out[1]
              sameInfo = false
            }
            if (this.transporterCheckInfo.CAAT != item.json[0].CAAT) {
              missingInfo[missingInfo.length] = 'CAAT: ' + this.transporterCheckInfo.CAAT + ' / ' + item.json[0].CAAT
              out_message = messages_out[1]
              sameInfo = false
            }
            if (this.transporterCheckInfo.SCAC != item.json[0].SCAC) {
              missingInfo[missingInfo.length] = 'SCAC: ' + this.transporterCheckInfo.SCAC + ' / ' + item.json[0].SCAC
              out_message = messages_out[1]
              sameInfo = false
            }
          }
        });

        //Check Folio from last uploaded file, user can NOT upload two files with same 'Folio Factura'
        let index = loadOrders.tables.length - 1
        let item = []
        if (loadOrders.tables.length > 0) {
          item = loadOrders.tables[index].json[0]
          loadOrders.tables.forEach((LO, key) => {
            if (LO.json[0]['Folio Factura'] == item['Folio Factura']
              && key != index) {
              missingInfo = ['Folio Factura : ' + item['Folio Factura']]
              out_message = messages_out[2]
            }
          })
        }

      }
      this.modal_ul_items = missingInfo
      return out_message
    },
    resetCheckInfo() {
      if (this.invoices.tables.length == 0) {
        this.transporterCheckInfo = []
      }
    },
    submit() {
      this.loading.submit = true
      let params = {
        invoice_items: this.invoices.tables.map(table => table.json),
        validation: false
      }
      if (this.$route.params.load_order_id != undefined) {
        params.load_order_id = this.$route.params.load_order_id
      }
      loadOrder.store(params).then(res => {
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: res.data.msg
        })
        this.loading.submit = false
        this.$router.push('/load_orders/' + res.data.load_order_id)
      }).catch(err => {
        console.log(err)
        this.loading.submit = false
      })
      this.modal_compare = false
    },
    compareReviewOrderInvoices() {
      this.loading.checkingInvoices = true
      let params = {
        invoice_items: this.invoices.tables.map(table => table.json)
      }
      loadOrder.getReviewOrderInvoices(params).then(res => {
        this.loading.checkingInvoices = false
        //comparar respuesta
        this.validationErrors = [[]]
        let out = this.compareResponseWithInvoices(res.data.data, params.invoice_items)
        this.modal_compare = out
      }).catch(err => {
        console.log(err)
      })
    },
    compareResponseWithInvoices(system, invoice) {

      let invoice_var = []
      let sameInfo = true;
      let checkFiles = true;
      let notFound = false
      let notSameLength = false
      let error = [];
      let errorList = [];
      this.errorsSameInfo = []

      system.forEach((system_var, idx) => {
        error[idx] = []
        errorList[idx] = []
        invoice_var = invoice[idx]
        notFound = false
        notSameLength = false
        let k = system_var[1].length - 1
        if (system_var[1][k] == 'No se encontró RO activo con ese Folio Factura') {
          sameInfo = false
          notFound = true
          error[idx].push(['Review Order Not found', '', 'Not Found'])
          errorList[idx].push(['Not Found', error[idx]])
          this.errorsSameInfo = errorList
        }


        if (system_var[1].length != invoice_var.length && !notFound) {
          sameInfo = false;
          notSameLength = true
          error[idx].push(['Distinta longitud', invoice_var.length, system_var[1].length])
          errorList[idx].push(['Longitud Invoice', error[idx]])
          this.errorsSameInfo = errorList
        }

        if (checkFiles && !notSameLength && !notFound) {
          system_var[1].forEach((item, index) => {
            error[idx] = []
            if (invoice_var[index]['Folio Factura'] != item.fields['Folio Factura']) {
              sameInfo = false
              error[idx].push(['Folio Factura', invoice_var[index]['Folio Factura'], item.fields['Folio Factura']])
            }
            if (invoice_var[index]['Bultos (Bundles)'] != item.fields['Bultos (Bundles)']) {
              sameInfo = false
              error[idx].push(['Bultos (Bundles)', invoice_var[index]['Bultos (Bundles)'], item.fields['Bultos (Bundles)']])
            }
            if (invoice_var[index]['Clave de pedimento'] != item.fields['Clave de pedimento']) {
              sameInfo = false
              error[idx].push(['Clave de pedimento', invoice_var[index]['Clave de pedimento'], item.fields['Clave de pedimento']])
            }
            if (invoice_var[index]['No. parte'] != item.fields['No. parte']) {
              sameInfo = false
              error[idx].push(['No. parte', invoice_var[index]['No. parte'], item.fields['No. parte']])
            }
            if (invoice_var[index]['Descripcion'] != item.fields['Descripcion']) {
              sameInfo = false
              error[idx].push(['Descripcion', invoice_var[index]['Descripcion'], item.fields['Descripcion']])
            }
            if (invoice_var[index]['Descripcion en ingles'] != item.fields['Descripcion en ingles']) {
              sameInfo = false
              error[idx].push(['Descripcion en ingles', invoice_var[index]['Descripcion en ingles'], item.fields['Descripcion en ingles']])
            }
            if (parseInt(invoice_var[index]['Cantidad']) != parseInt(item.fields['Cantidad'])) {
              sameInfo = false
              error[idx].push(['Cantidad', invoice_var[index]['Cantidad'], item.fields['Cantidad']])
            }
            if (invoice_var[index]['Unidad medida'] != item.fields['Unidad medida']) {
              sameInfo = false
              error[idx].push(['Unidad medida', invoice_var[index]['Unidad medida'], item.fields['Unidad medida']])
            }
            if (invoice_var[index]['Unidad medida tarifa'] != item.fields['Unidad medida tarifa']) {
              sameInfo = false
              error[idx].push(['Unidad medida tarifa', invoice_var[index]['Unidad medida tarifa'], item.fields['Unidad medida tarifa']])
            }
            if (invoice_var[index]['Factor de conversion'] != item.fields['Factor de conversion']) {
              sameInfo = false
              error[idx].push(['Factor de conversion', invoice_var[index]['Factor de conversion'], item.fields['Factor de conversion']])
            }
            if (invoice_var[index]['WareHouse'] != item.fields['WareHouse']) {
              sameInfo = false
              error[idx].push(['WareHouse', invoice_var[index]['WareHouse'], item.fields['WareHouse']])
            }
            if (invoice_var[index]['Pais de origen'] != item.fields['Pais de origen']) {
              sameInfo = false
              error[idx].push(['Pais de origen', invoice_var[index]['Pais de origen'], item.fields['Pais de origen']])
            }
            if (invoice_var[index]['Peso KG'] != item.fields['Peso KG']) {
              sameInfo = false
              error[idx].push(['Peso KG', invoice_var[index]['Peso KG'], item.fields['Peso KG']])
            }
            if (invoice_var[index]['Peso LB'] != item.fields['Peso LB']) {
              sameInfo = false
              error[idx].push(['Peso LB', invoice_var[index]['Peso LB'], item.fields['Peso LB']])
            }
            if (invoice_var[index]['V. Unit. Compra'] != item.fields['V. Unit. Compra']) {
              sameInfo = false
              error[idx].push(['V. Unit. Compra', invoice_var[index]['V. Unit. Compra'], item.fields['V. Unit. Compra']])
            }
            if (invoice_var[index]['V. Unit. Comercial'] != item.fields['V. Unit. Comercial']) {
              sameInfo = false
              error[idx].push(['V. Unit. Comercial', invoice_var[index]['V. Unit. Comercial'], item.fields['V. Unit. Comercial']])
            }
            if (invoice_var[index]['Valor Total USD'] != item.fields['Valor Total USD']) {
              sameInfo = false
              error[idx].push(['Valor Total USD', invoice_var[index]['Valor Total USD'], item.fields['Valor Total USD']])
            }
            if (invoice_var[index]['Marca'] != item.fields['Marca']) {
              sameInfo = false
              error[idx].push(['Marca', invoice_var[index]['Marca'], item.fields['Marca']])
            }
            if (invoice_var[index]['Modelo'] != item.fields['Modelo']) {
              sameInfo = false
              error[idx].push(['Modelo', invoice_var[index]['Modelo'], item.fields['Modelo']])
            }
            if (invoice_var[index]['Serie'] != item.fields['Serie']) {
              sameInfo = false
              error[idx].push(['Serie', invoice_var[index]['Serie'], item.fields['Serie']])
            }
            if (idx == system.length - 1) {
              checkFiles = false
            }
            if (error[idx].length > 0) {
              errorList[idx].push(['No. Parte: ' + item.fields['No. parte'], error[idx]])
            }
          })
          if (errorList[idx].length > 0) {
            this.errorsSameInfo = errorList
          }
        }
      })
      if (!sameInfo) {
        let indice = this.invoices.tables.length - 1
        this.invoices.tables.splice(indice, 1);
      }
      return !sameInfo
    },
    showBackValidations() {
      this.errorsSameInfo = []
      this.loading.validationBack = true
      let params = {
        invoice_items: this.invoices.tables.map(table => table.json),
        validation: true
      }

      loadOrder.store(params).then(res => {
        this.validationErrors = res.data.errors
        this.modal_compare = true
        this.loading.validationBack = false
      }).catch(err => {
        console.log(err)
        this.loading.validationBack = false
      })
    },
    openAddTrailer() {
      this.modal_compare = false
      this.$store.dispatch('toggleSidebar', 'add-trailer')
    }
  }
}
</script>

<style lang="scss">
.custom-icon {
  width: 16px;
  height: 16px;
  top: 20%;
  .material-icons {
    font-size: 14px;
  }
}

.div-validation-list {
  display: inline-block;
  padding: 5px;
}

.text-validation-list {
  clear: left;
  text-align: right;
  vertical-align: middle;
  line-height: 25px;
}

.icon-validation-list {
  display: inline-block;
  vertical-align: top;
}
</style>